module.exports = __webpack_public_path__ + "img/logo.d62dfb32.png";